import {
    useNavigate,
    useParams
} from "react-router-dom";
import * as yup from "yup";
import { ILocaleStrings } from "loc/locale.interfaces";
import { useL10n } from "context/l10n-context";
import Form from "components/forms/form/form";
import TextField from "components/forms/text-field/text-field";
import TextareaField from "components/forms/textarea-field/textarea-field";

export default function EditApplicationRole() {
    const { t } = useL10n<ILocaleStrings>();
    const params = useParams();
    const navigate = useNavigate();

    const schema = yup.object().shape({ //<IApplicationRole>
        id: yup
            .number()
            .required(),
        name: yup
            .string()
            .min(2, t("ppaValidationMinLengthMessage", { field: t("name") }))
            .max(64, t("ppaValidationMaxLengthMessage", { field: t("name") }))
            .required(t("ppaValidationRequiredMessage", { field: t("name") })),
        description: yup
            .string()
            .max(256, t("ppaValidationMaxLengthMessage", { field: t("description") }))
            .optional()
    });

    const onSuccess = () => {
        navigate("/settings/permissions/application-roles");
    }

    const onCancel = () => {
        navigate("/settings/permissions/application-roles");
    }

    return (
        <Form
            schema={schema}
            getExistingApiUrl={`/api/settings/permissions/application-roles/${params.id}`}
            apiUrl={`/api/settings/permissions/application-roles/${params.id}`}
            method="PUT"
            onSuccess={onSuccess}
            onCancel={onCancel}
            submitLabel="save"
            submittingLabel="saving"
            cancelLabel="cancel">
            <TextField
                label="name"
                fieldName="name"
                required />
            <TextareaField
                label="description"
                fieldName="description"
                rows={3} />
        </Form>
    );
}